module.exports = __webpack_public_path__ + "img/blue.6597f3c1.webp";